import { addDays, format, isAfter } from 'date-fns';
import { SubscriberModel } from '../../subscriber/models/SubscriberModel';

function getDueDate():Date {
    let dueDate = new Date(new Date().setDate(15))

    if (isAfter(new Date(), dueDate)) {
        dueDate = addDays(new Date(), 7)
    }

    return dueDate
}

interface BillingDocumentCreationNormalized {
    billingDueStartDate: string;
    billingDueEndDate: string;
    billetDueDate: string;
    invoiceIssueDate: string;   
    idSubscriber?: string;
}

export class BillingDocumentCreationModel {
    billingDueStartDate: Date|string;
    billingDueEndDate: Date|string;
    billetDueDate: Date|string = getDueDate();
    invoiceIssueDate: Date|string = new Date();
    subscriber?: SubscriberModel

    constructor(b?:Partial<BillingDocumentCreationModel>) {
        Object.assign(this, b)
    }

    isValid():boolean {
        return !!this.billingDueStartDate &&
            !!this.billingDueEndDate &&
            !!this.billetDueDate &&
            !!this.invoiceIssueDate            
    }

    getInfoFormatted():BillingDocumentCreationNormalized {
        return {
            billingDueStartDate: format(this.billingDueStartDate as Date, 'yyyy-MM-dd'), 
            billingDueEndDate: format(this.billingDueEndDate as Date, 'yyyy-MM-dd'),
            billetDueDate: format(this.billetDueDate as Date, 'yyyy-MM-dd'),
            invoiceIssueDate: format(this.invoiceIssueDate as Date, 'yyyy-MM-dd'),
            idSubscriber: this.subscriber?.id,
        }
    }
}
